// Curash FAQ page — accordion + category tabs + live search.
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.cfaqWired === '1') return;
    root.dataset.cfaqWired = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cfaq-item]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cfaq-tab]'));
    var search = root.querySelector('[data-cfaq-search]');
    var empty = root.querySelector('[data-cfaq-empty]');

    var activeCat = 'all';
    var query = '';

    // ---- Accordion ----
    items.forEach(function (item) {
      var q = item.querySelector('[data-cfaq-q]');
      var a = item.querySelector('[data-cfaq-a]');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        if (isOpen) {
          a.style.maxHeight = '0px';
          item.classList.remove('is-open');
          q.setAttribute('aria-expanded', 'false');
        } else {
          a.style.maxHeight = a.scrollHeight + 'px';
          item.classList.add('is-open');
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });

    function applyFilters() {
      var anyVisible = false;
      items.forEach(function (item) {
        var cat = (item.getAttribute('data-cfaq-cat') || '').toLowerCase();
        var text = (item.getAttribute('data-cfaq-text') || '').toLowerCase();
        var matchCat = activeCat === 'all' || cat === activeCat;
        var matchQ = !query || text.indexOf(query) > -1;
        var show = matchCat && matchQ;
        item.style.display = show ? '' : 'none';
        if (show) anyVisible = true;
        // collapse hidden items
        if (!show && item.classList.contains('is-open')) {
          item.classList.remove('is-open');
          var a = item.querySelector('[data-cfaq-a]');
          if (a) a.style.maxHeight = '0px';
          var q = item.querySelector('[data-cfaq-q]');
          if (q) q.setAttribute('aria-expanded', 'false');
        }
      });
      if (empty) empty.classList.toggle('is-shown', !anyVisible);
    }

    // ---- Category tabs ----
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activeCat = (tab.getAttribute('data-cfaq-tab') || 'all').toLowerCase();
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        applyFilters();
      });
    });

    // ---- Search ----
    if (search) {
      search.addEventListener('input', function () {
        query = search.value.trim().toLowerCase();
        applyFilters();
      });
    }

    applyFilters();
  }

  function boot() {
    document.querySelectorAll('[data-curash-faq]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
